<section class="banner">
  <div class="container">
    <div class="row flex-grow">
      <div class="col-12 col-md-10 col-lg-8">
        <div id="alertslides" class="carousel slide " data-ride="carousel">


          <!-- <div id="alertslides" class="carousel slide" data-ride="carousel"
                    >
                     <div class="carousel-inner">
                         <div class="carousel-item" *ngFor="let item of arrayListSection1; let i = index"
                             [ngClass]="{'active': i === 0}">
                             <img  [src]="item?.BytesData" alt="First slide" class="carousel-img d-block w-100">
                             <a class="carousel-caption" [href]="item?.Url" target="_blank">
                                 <p>{{item?.description}}</p>
                             </a>
                         </div>
                     </div>
                     <button class="carousel-control-prev d-none d-lg-block" type="button" data-target="#alertslides"
                         data-slide="prev">
                         <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                         <span class="sr-only">Previous</span>
                     </button>
                     <button class="carousel-control-next d-none d-lg-block" type="button" data-target="#alertslides"
                         data-slide="next">
                         <span class="carousel-control-next-icon" aria-hidden="true"></span>
                         <span class="sr-only">Next</span>
                     </button>
                 </div> -->



          <div class="carousel-inner hw">
            <div class="carousel-item active">
              <img src="assets/images/s1.jpg" alt="Slide 1" class="carousel-img d-block w-100">
              <div class="carousel-caption">
                <!-- <p>First slide description</p> -->
              </div>
            </div>
            <div class="carousel-item">
              <img src="assets/images/s2.jpg" alt="Slide 2" class="carousel-img d-block w-100">
              <div class="carousel-caption">
                <!-- <p>Second slide description</p> -->
              </div>
            </div>
            <div class="carousel-item">
              <img src="assets/images/s3.jpg" alt="Slide 3" class="carousel-img d-block w-100">
              <div class="carousel-caption">
                <!-- <p>Third slide description</p> -->
              </div>
            </div>
            <div class="carousel-item">
              <img src="assets/images/s4.jpg" alt="Slide 4" class="carousel-img d-block w-100">
              <div class="carousel-caption">
                <!-- <p>Third slide description</p> -->
              </div>
            </div>
          </div>
          <button class="carousel-control-prev d-none d-lg-block" type="button" data-target="#alertslides"
            data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </button>
          <button class="carousel-control-next d-none d-lg-block" type="button" data-target="#alertslides"
            data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </button>
        </div>
        <app-dashboard></app-dashboard>
      </div>
      <div class="col-lg-4 " style="height: 480px !important;">
        <app-highlights></app-highlights>
      </div>
      <!-- // BANNER for Attention -->
      <div class="epads-downtime-banner">
        <div class="epads-downtime-scroll">
          <!-- <p style="color:white;">
            <b>⚠ Attention EPADS Users:</b> Due to an unexpected error, EPADS will remain unavailable today.
            The bid submission deadlines and openings for today (<strong>10-Nov-2025</strong>) have been
            extended for <strong>24 hours</strong>.
            <br><br>
            We regret any inconvenience this may cause and appreciate your understanding.
          </p> -->

          <div style="
              display:flex;
              align-items:center;
              gap:12px;
              color:white;
            ">
            <!-- Left side: NEW tag (vertically centered) -->
            <div>
              <strong><span class="new-tag blink">New</span></strong>
            </div>

            <!-- Right side: Links -->
            <div>
              <a href="assets/docs/Notice.pdf" target="_blank" style="color:white; display:block;">
                Important Notice for EPADS Vendors.
              </a>

              <span style="color:white; display:block;">
                <a href="assets/docs/NoticeProcuringAgencies.pdf" target="_blank" style="color:white;">
                  Important Notice for Procuring Agencies.
                </a>
                <a href="https://www.youtube.com/watch?v=MTBw5MBu7H0" target="_blank"
                  style="color:white; margin-left:6px; text-decoration:underline;">
                  Click here for video.
                </a>
              </span>

              <a href="assets/docs/PPRALeadsReforms.pdf" target="_blank"
                style="color:white; display:block; margin-top:4px;">
                PPRA Leads Reforms; EPADS Brings Transparency, Accountability in Procurement.
              </a>
            </div>
          </div>



        </div>
      </div>
    </div>
  </div>
</section>
<!-- Floating Social Media Icons -->
<div class="floating-icons">
  <a href="https://www.facebook.com/people/Public-Procurement-Regulatory-Authority-Islamabad/61564881150073/?mibextid=kFxxJD"
    target="_blank" class="social-icon facebook">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
      <path
        d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z" />
    </svg>
  </a>

  <a href="https://x.com/PPRAPakistan" target="_blank" class="social-icon twitter">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path
        d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z" />
    </svg>
  </a>

  <a href="https://www.linkedin.com/company/public-procurement-regulatory-authority-pakistan/" target="_blank"
    class="social-icon linkedin">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
      <path
        d="M100.28 448H7.4V148.9h92.88zM53.79 108.1c-31.86 0-57.79-25.94-57.79-57.8S21.92 0 53.79 0c31.85 0 57.79 25.94 57.79 57.79s-25.94 57.8-57.79 57.8zM447.9 448h-92.7V302.4c0-34.7-.7-79.3-48.3-79.3-48.4 0-55.8 37.8-55.8 76.9V448h-92.6V148.9h88.9v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.4 61.8 111.4 142.3V448z" />
    </svg>
  </a>

  <a href="https://www.youtube.com/@PPRAEPADS" target="_blank" class="social-icon youtube">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
      <path
        d="M549.7 124.1C534.6 81.6 500.9 47.9 458.4 32.8 414.6 16.6 288 16 288 16S161.4 16.6 117.6 32.8c-42.5 15.1-76.2 48.8-91.3 91.3-16.2 44.5-16.2 137.9-16.2 137.9s0 93.4 16.2 137.9c15.1 42.5 48.8 76.2 91.3 91.3 43.8 16.2 170.4 16.8 170.4 16.8s126.6-.6 170.4-16.8c42.5-15.1 76.2-48.8 91.3-91.3 16.2-44.5 16.2-137.9 16.2-137.9s0-93.4-16.2-137.9zM231.5 334.3V177.7l142.3 78.3-142.3 78.3z" />
    </svg>
  </a>
</div>
<div class="clear p-3"></div>
<section class="container">
  <div class="row">
    <div class="col-8">
      <section class="container">
        <h2>Quick <span class="font-weight-light"> Access</span></h2>
        <div class="clear p-2"></div>
        <div class="horizontal-scroll-container" *ngIf="IsPublishToPortalSection3">
          <div class="row flex-nowrap">
            <div class="col-lg-4 mb-3" *ngFor="let item of arrayListSection3">
              <div class="announcement_box h-100">
                <img [src]="item?.BytesData" style="height: 100%;">
                <a [href]="item?.Url === 'www.assets/apk/epads.apk' ? '../assets/apk/epads.apk' : item?.Url">
                  <div>
                    <span class="bar bg-primary"></span>
                    <h4 class="text-white">{{item?.title}}</h4>
                    <p class="text-white">{{item?.description}}</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>



      </section>
    </div>

    <div class="col-4">
      <section class="">
        <div class="mb-0 card " style="height: 369px !important;">
          <h5 class="card-header  text-center"> Highlights</h5>
          <div class="clear p-2"></div>
          <div class="">
            <div class="card-body scroll-container" style="max-height: 305px;">
              <ul *ngIf="allHighlights?.length > 0; else elseblock" class="highlight">

                <li *ngFor="let highlight of allHighlights">
                  <strong><span *ngIf="highlight.priority==1" class="new-tag">New </span>{{ highlight?.title }}</strong>
                  <small>
                    <ng-container *ngIf="highlight?.urlLink; else plainDescription">
                      <br>
                      <a [href]="highlight.urlLink" target="_blank" class="text-info" [title]="highlight.description">
                        {{ highlight.description }}
                      </a>
                    </ng-container>
                    <ng-template #plainDescription>
                      <br>{{ highlight?.description }}
                    </ng-template>
                  </small>
                  <br>
                  <small>
                    <a *ngIf="highlight?.attachmentId > 0"
                      (click)="getAttachmentByID(highlight?.attachmentId, highlight?.fileGuid)" target="_blank"
                      class="text-info">
                      Download File
                    </a>
                  </small>
                </li>
              </ul>

              <ng-template #elseblock>
                <p class="loading">No highlights available.</p>
              </ng-template>
            </div>
          </div>


        </div>

      </section>
    </div>
  </div>
</section>
<div class="clear"></div>
<div class="clear p-3"></div>
<section class="bg-light py-5">
  <div class="container">
    <!--div class="row justify-content-center" >
		<div *ngFor="let item of arrayList" class="col-6 col-sm-4 col-md-3 col-lg-2 text-center">
			<a [href]="item?.Url" target="_blank"><img [src]="item.BytesData" class="img-center" width="180" height="180"></a>
		</div>
	</div>
	<div class="clear p-3"></div>
	<hr>
	<div class="row align-items-center" *ngIf="IsPublishToPortalSection5==true">
		<div class="col-md-6" *ngFor="let item of arrayListSection5">
		  <div *ngIf="item?.Url === 'https://eprocure.gov.pk/#/auth/login'">
			<h3><a target="_blank" [href]="item?.Url">{{item?.title}}</a></h3>
			<h4 class="text-black">{{item?.description}}</h4>
			<p class="font-weight-medium ml-2">{{item?.DescriptionDetail}}</p>
		  </div>
		  <div *ngIf="item?.Url === 'https://eprocure.gov.pk/#/auth/login'">
			<iframe width="80%" height="150%" src="https://www.youtube.com/embed/tgbNymZ7vqY"></iframe>
		  </div>
		  <div *ngIf="item?.Url === 'https://eprocure.gov.pk/#/supplier/registration'">
			<div class="media">
			  <a target="_blank" [href]="item?.Url"><img [src]="item?.BytesData" class="mr-3"></a>
			  <div class="media-body">
				<h6><a target="_blank" [href]="item?.Url">{{item?.title}}</a></h6>
				<p>{{item?.DescriptionDetail}}</p>
			  </div>
			</div>
		  </div>
		</div>
	  </div>

	<hr>
	<div class="row align-items-center" *ngIf="IsPublishToPortalSection6==true">
		<div class="col-lg-9" *ngFor="let item of arrayListSection6">
			<div class="row align-items-center">
				<div class="col-6 col-sm-4">
					<img [src]="item?.BytesData" class="img-thumbnail">
				</div>
				<div class="col-8 col-sm-8">
					<h5 class="font-weight-medium">{{item?.title}}</h5>
					<p class="text-black-50 font-weight-medium Roboto">{{item?.description}}</p>
					<p>{{item?.DescriptionDetail}}</p>
				</div>
			</div>
		</div>
		<div class="col-lg-3 text-center" *ngIf="IsPublishToPortalSection6_1==true">
			<img *ngFor="let item of arrayListSection6_1" [src]="item?.BytesData" class="img-center">
		</div>
	</div>
	<hr--->
    <div class="clear p-2"></div>
    <h2>Tender <span class="font-weight-light">& Advertisments</span></h2>

    <div class="row">
      <!-- <div class="col-lg-3 col-md-6">
            <div class="card h-100">
                <h5 class="font-weight-bold">EPADS</h5>
                <hr>
                <div *ngIf="IsPublishToPortalSection7==true">
                    <div class="card-header" *ngFor="let item of arrayListSection7">
                        <marquee loop="true" width="100%">
                            <a target="_blank" [href]="item?.Url"
                                class="h5 card-title mb-0 font-weight-semi-bold">{{item?.DescriptionDetail}}</a>
                        </marquee>
                    </div>
                </div>
                <div class="card-body">
                    <h6 class="well font-weight-medium p-3 mb-3">
                        <i class="far fa-hand-point-right text-primary mr-2"></i>
                        <a [routerLink] (click)="openEpadtenders()">Expression of Interests-EOI</a> <small
                            class="ml-2">({{dashboardDataModel?.totalEOICount| number}})</small>
                    </h6>
                    <h6 class="well font-weight-medium p-3 mb-3">
                        <i class="far fa-hand-point-right text-primary mr-2"></i>
                        <a [routerLink] (click)="PQ()">Pre-Qualifications PQ</a> <small
                            class="ml-2">({{dashboardDataModel?.totalPQCount | number}})</small>
                    </h6>
                    <h6 class="well font-weight-medium p-3 mb-3">
                        <i class="far fa-hand-point-right text-primary mr-2"></i>
                        <a  [routerLink]="'/tenders/Epadtenders'" >Tenders Published</a> <small
                            class="ml-2">({{dashboardDataModel?.ePADSTendersCounts | number}})</small>
                    </h6>
                     <h6 class="well font-weight-medium p-3 mb-3">
                        <i class="far fa-hand-point-right text-primary mr-2"></i>
                        <a [routerLink]="['/tenders/PQTenders']">Prequalification Notice</a> <small
                            class="ml-2">({{this.Records[0]?.PQNotice}})</small>
                    </h6> -->
      <!-- <h6 class="well font-weight-medium p-3 mb-3">
                        <i class="far fa-hand-point-right text-primary mr-2"></i>
                        <a [routerLink]="['/tenders/SADTenders']">Auction/Disposal</a> <small
                            class="ml-2">({{this.Records[0]?.SalesAuctionDisposal}})</small>
                    </h6> -->
      <!-- <h6 class="well font-weight-medium p-3 mb-0">
                        <i class="far fa-hand-point-right text-primary mr-2"></i>
                        <a href="https://ppra.org.pk/jobs.asp" target="_blank">Job Advertisements</a> <small
                            class="ml-2">(84)</small>
                    </h6> -->
      <!-- <div class="d-flex mt-3 flex-col">
                        <h6 class="font-weight-bold">Last Update: {{currentDate |date}}</h6>
                        <h6 class="font-weight-bold"><a [routerLink]="['/tenders/activetenders']">Total Active Tenders:
                                {{this.Records[0]?.TotalActiveTenders}}</a></h6>
                    </div> -->
      <!-- </div>
            </div>
            <div class="row align-items-center" *ngIf="IsPublishToPortalSection7_2==true">
                <div class="col-md-8 align-items-center">
                    <div class="row align-items-center">
                        <div class="col-sm-4 text-center" *ngFor="let item of arrayListSection7_2"><a
                                [href]="item?.Url"><img [src]="item?.BytesData" class="img-center"></a></div>
                    </div>
                    <div class="clear py-2"></div>
                    <a href="https://webmail.ppra.org.pk/interface/root" target="_blank"
                        class="btn btn-primary w-100 font-weight-medium"><i class="far fa-envelope mr-2"></i> Only for
                        PPRA Employees</a>
                </div>
                <div class="col-md-4 align-items-center" *ngIf="IsPublishToPortalSection7_3==true">
                    <ng-container *ngFor="let item of arrayListSection7_3; let i = index">
                        <a [href]="item?.Url" target="_blank"><img [src]="item?.BytesData" class="img-center"></a>
                        <div *ngIf="i === 0" class="w-100 clear py-1"></div>
                    </ng-container>
                </div>

            </div> -->
      <!-- </div> -->

      <div class="col-lg-4 col-md-4">

        <div class="card h-100 flxf">
          <h5 class="font-weight-bold headep1">Procurement & Notices </h5>
          <hr>
          <div *ngIf="IsPublishToPortalSection7==true">
            <div class="card-header" *ngFor="let item of arrayListSection7">
              <marquee loop="true" width="100%">
                <a target="_blank" [href]="item?.Url"
                  class="h5 card-title mb-0 font-weight-semi-bold">{{item?.DescriptionDetail}}</a>
              </marquee>
            </div>
          </div>
          <div class="card-body">
            <h6 class="well font-weight-medium p-3 mb-3">
              <i class="far fa-hand-point-right text-primary mr-2"></i>
              <a [routerLink]="['/tenders/NoticeTenders']">Tender Notice</a> <small class="ml-2">({{
                tenderCount?.[0]?.TenderNotice}})</small>
            </h6>
            <h6 class="well font-weight-medium p-3 mb-3">
              <i class="far fa-hand-point-right text-primary mr-2"></i>
              <a [routerLink]="['/tenders/PQTenders']">Pre-Qualifications PQ</a> <small class="ml-2">({{
                tenderCount?.[0]?.PQNotice}})</small>
            </h6>
            <h6 class="well font-weight-medium p-3 mb-3">
              <i class="far fa-hand-point-right text-primary mr-2"></i>
              <a [routerLink]="['/tenders/RFPTenders']">Request for Proposal</a> <small class="ml-2">({{
                tenderCount?.[0]?.RFP}})</small>
            </h6>

            <h6 class="well font-weight-medium p-3 mb-3">
              <i class="far fa-hand-point-right text-primary mr-2"></i>
              <a [routerLink]="['/tenders/EOITenders']">Expression of Interests-EOI</a>
              <!-- <small  class="ml-2">({{this.Records[0]?.EOI}})</small> -->
              <small class="ml-2">({{ tenderCount?.[0]?.EOI || 0 }})</small>
            </h6>


            <h6 class="well font-weight-medium p-3 mb-3">
              <i class="far fa-hand-point-right text-primary mr-2"></i>
              <a [routerLink]="['/tenders/SADTenders']">Sales/Auction/Disposal</a> <small class="ml-2">({{
                tenderCount?.[0]?.SalesAuctionDisposal}})</small>
            </h6>


          </div>
        </div>
        <div class="row align-items-center" *ngIf="IsPublishToPortalSection7_2==true">
          <div class="col-md-8 align-items-center">
            <div class="row align-items-center">
              <div class="col-sm-4 text-center" *ngFor="let item of arrayListSection7_2"><a [href]="item?.Url"><img
                    [src]="item?.BytesData" class="img-center"></a></div>
            </div>
            <div class="clear py-2"></div>
            <a href="https://webmail.ppra.org.pk/interface/root" target="_blank"
              class="btn btn-primary w-100 font-weight-medium"><i class="far fa-envelope mr-2"></i> Only for
              PPRA Employees</a>
          </div>
          <div class="col-md-4 align-items-center" *ngIf="IsPublishToPortalSection7_3==true">
            <ng-container *ngFor="let item of arrayListSection7_3; let i = index">
              <a [href]="item?.Url" target="_blank"><img [src]="item?.BytesData" class="img-center"></a>
              <div *ngIf="i === 0" class="w-100 clear py-1"></div>
            </ng-container>
          </div>

        </div>
      </div>
      <div class="col-lg-8 col-md-6 ">
        <div class="row" *ngIf="IsPublishToPortalSection8==true">
          <div class="col-lg-12 card h-100">
            <div class=" h-100 flxf ">
              <h5 class="font-weight-bold headep">e-PADS Statistics</h5>
              <hr>
              <div class="row">
                <div class="col-lg-6">
                  <div class="precurement_widgets">
                    <i class="icon"><img src="../assets/images/icons/procurement-plan.svg" width="40"></i>
                    <div>
                      <h6> Procurement Plans</h6>
                      <h3 [@fadeIn]>{{dashboardDataModel?.ePADSPlansCounts || 0 | number}}</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="precurement_widgets">
                    <i class="icon"><img src="../assets/images/icons/EPADS-tenders.svg" width="40"></i>
                    <div>
                      <h6>Tenders Published</h6>
                      <h3 [@fadeIn]> {{dashboardDataModel?.ePADSTendersCounts || 0 | number}}</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="precurement_widgets">
                    <i class="icon"><img src="../assets/images/icons/procurement-plan.svg" width="40"></i>
                    <div>
                      <h6>Expression of Interest (EOIs)</h6>
                      <h3>{{dashboardDataModel?.totalEOICount || 0 | number}}</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="precurement_widgets">
                    <i class="icon"><img src="../assets/images/icons/EPADS-tenders.svg" width="40"></i>
                    <div>
                      <h6>Pre-Qualifications (PQs)</h6>
                      <h3>{{dashboardDataModel?.totalPQCount || 0 | number}}</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="precurement_widgets">
                    <i class="icon"><img src="../assets/images/icons/evaluation-report.svg" width="40"></i>
                    <div>
                      <h6>Evaluation Reports Published</h6>
                      <h3>{{dashboardDataModel?.ePADSEvalutaionsCounts || 0 | number}}</h3>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="precurement_widgets mb-0">
                    <i class="icon"><img src="../assets/images/icons/contract.svg" width="40"></i>
                    <div>
                      <h6>Contracts Awarded</h6>
                      <h3>{{dashboardDataModel?.ePADSContractsCounts || 0 | number}}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-6" *ngFor="let item of arrayListSection8">
                    <div class="card card-body  h-100">
                        <h6 class="font-weight-bold">{{item?.title}}</h6>
                        <hr>
                        <p>{{item?.description}}</p>
                        <ul class="pl-3" *ngIf="item?.DescriptionDetail">
                            <ng-container *ngFor="let part of splitDescription(item.DescriptionDetail); let i = index">
                                <li>{{ part.trim() }}</li>
                                <ng-container *ngIf="i < splitDescription(item.DescriptionDetail).length - 1">
                                    OR
                                </ng-container>
                            </ng-container>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6" *ngIf="IsPublishToPortalSection8_1==true">
                    <div class="card card-body  h-100">
                        <h6 class="font-weight-bold">Contact for Queries/Support</h6>
                        <hr>
                        <div *ngFor="let item of arrayListSection8_1">
                            <h6 class="font-weight-medium">{{ item?.title }}</h6>
                            <ul class="list-unstyled pl-3 pb-3">
                                <ng-container *ngFor="let part of splitDescriptionDetail(item.DescriptionDetail)">
                                    <ng-container *ngIf="part.includes('Tel:') || part.includes('Fax:')">
                                        <li class="font-weight-normal">{{ part }}</li>
                                    </ng-container>
                                    <ng-container *ngIf="part.includes('Email:')">
                                        <li class="font-weight-normal">Email:</li>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="!part.includes('Tel:') && !part.includes('Fax:') && !part.includes('Email:')">
                                        <li class="text-primary">
                                            <a [href]="'mailto:' + part" class="text-primary">{{ part}}</a>
                                        </li>
                                    </ng-container>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                </div> -->

        </div>
        <div *ngIf="IsPublishToPortalSection9==true">
          <a *ngFor="let item of arrayListSection9" [href]="item?.Url" target="_blank"><img [src]="item?.BytesData"
              class="img-center mt-2" title="Anti-Fraud"></a>
        </div>
      </div>
    </div>

  </div>
  <section class="">
    <div class="container">
      <div class="clear p-2"></div>
      <div class="row Flx" *ngIf="IsPublishToPortalSection4 == true">
        <div class="col-md-6 col-lg-4 mb-4 pb-2 wow fadeInUp">
          <a [routerLink]="['/tenders/type', 'Works']"
            class="services_widgets d-flex align-items-center justify-content-between gray">
            <span class="Service-img"><img src="../assets/images/icons/procurement-plan.svg" alt="Works"></span>
            <span class="text-center">Works</span>
            <span><i class="fa fa-arrow-right col-auto"></i></span>
          </a>
        </div>

        <div class="col-md-6 col-lg-4 mb-4 pb-2 wow fadeInUp">
          <a [routerLink]="['/tenders/type', 'Goods']"
            class="services_widgets d-flex align-items-center justify-content-between gray">
            <span class="Service-img"><img src="../assets/images/icons/contract.svg" alt="Goods"></span>
            <span class="text-center">Goods</span>
            <span><i class="fa fa-arrow-right col-auto"></i></span>
          </a>
        </div>

        <div class="col-md-6 col-lg-4 mb-4 pb-2 wow fadeInUp">
          <a [routerLink]="['/tenders/type', 'Services']"
            class="services_widgets d-flex align-items-center justify-content-between gray">
            <span class="Service-img"><img src="../assets/images/icons/EPADS-tenders.svg" alt="Services"></span>
            <span class="text-center">Services</span>
            <span><i class="fa fa-arrow-right col-auto"></i></span>
          </a>
        </div>

      </div>
    </div>
  </section>
</section>


<div class="clear p-4"></div>
<div class="clear p-2"></div>
<section class="">
  <div class="container">
    <h2>Services <span class="font-weight-light">& Information</span></h2>
    <div class="clear p-2"></div>
    <div class="row Flx" *ngIf="IsPublishToPortalSection4 == true">
      <div class="col-md-6 col-lg-4 mb-4 pb-2 wow fadeInUp" *ngFor="let item of arrayListSection4">
        <a [href]="item?.Url"
          [ngClass]="['services_widgets', 'd-flex', 'align-items-center', 'justify-content-between', 'gray']">
          <!-- , getClassForUrl(item?.Url) -->
          <span class="Service-img"><img [src]="item?.BytesData"></span>
          <span class="text-center">{{item?.title}}</span>
          <span><i class="fa fa-arrow-right col-auto"></i></span>
        </a>
      </div>
    </div>
  </div>
</section>
<div class="clear p-4"></div>
<section class="bg-light py-5"> <!-- bg-landmarks -->
  <div class="container">
    <div class="row">
      <!-- <div class="col-lg-12 pb-4">
                <h2>Other <span class="font-weight-light"> PPRA Links</span></h2>
            </div> -->
      <div class="col-lg-12">
        <div class="row">
          <a href="https://www.ajkppra.gov.pk" target="_blank"
            class="col-lg-2 col-md-4 col-sm-6 services_widgets nav-link d-flex align-items-center justify-content-center gray gap-1">
            <span class="MMenu-icons">
              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 43.77">
                <path id="ajk"
                  d="M47.37,42.51h-4.1v-24.01c0-.35-.28-.63-.63-.63h-10.13v-3.64s0,0,0-.01,0,0,0-.01v-2.55c0-4.49-3.49-8.18-7.91-8.5V.63c0-.35-.28-.63-.63-.63s-.63.28-.63.63v2.53c-4.41.32-7.91,4.01-7.91,8.5v2.55s0,0,0,.01,0,0,0,.01v3.64H5.17c-.35,0-.63.28-.63.63v24.01H.63c-.35,0-.63.28-.63.63s.28.63.63.63h46.75c.35,0,.63-.28.63-.63s-.28-.63-.63-.63ZM23.98,4.37c4.01,0,7.28,3.27,7.28,7.28v1.94h-14.56v-1.94c0-4.01,3.27-7.28,7.28-7.28ZM16.7,14.84h14.56v3.03h-14.56v-3.03ZM16.07,19.12h25.94v15.87h-10.23v-1.37c0-.25.07-6.19-7.52-9.62-.16-.07-.44-.07-.6,0-7.59,3.43-7.53,9.37-7.52,9.61v1.38H5.8v-15.87h10.28ZM30.53,42.51h-13.14v-8.91c0-.22-.02-5.27,6.57-8.35,6.59,3.09,6.57,8.14,6.57,8.37v8.9ZM5.8,36.25h10.34v6.26H5.8v-6.26ZM31.78,42.51v-6.26h10.23v6.26h-10.23Z" />
              </svg>
            </span>
            <span class="text-center small-text">AJ&K PPRA</span>
          </a>
          <a href="https://bppthree.vdc.services" target="_blank"
            class="col-lg-2 col-md-4 col-sm-6 services_widgets nav-link d-flex align-items-center justify-content-center gray gap-1">
            <span class="MMenu-icons">
              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 39.99">
                <g id="quetta">
                  <path
                    d="M21.04,14.91h5.78c.35,0,.63-.28.63-.63v-3.57c0-.35-.28-.63-.63-.63h-5.78c-.35,0-.63.28-.63.63v3.57c0,.35.28.63.63.63ZM21.67,11.34h4.53v2.32h-4.53v-2.32Z" />
                  <path
                    d="M47.37,16.09c.35,0,.63-.28.63-.63s-.28-.63-.63-.63h-6.24s-.05-.05-.08-.06l-3.3-1.27v-1.71c0-.35-.28-.63-.63-.63h-6.84v-2.63c0-.18-.08-.36-.22-.47l-5.49-4.72v-.61c.48-.23.82-.72.82-1.29,0-.8-.65-1.44-1.44-1.44s-1.44.65-1.44,1.44c0,.54.31,1,.76,1.24v.65l-5.49,4.72c-.14.12-.22.29-.22.47v2.63h-6.84c-.35,0-.63.28-.63.63v1.71l-3.3,1.27s-.05.05-.08.06H.63c-.35,0-.63.28-.63.63s.28.63.63.63h1.41v5.89h-.96c-.35,0-.63.28-.63.63s.28.63.63.63h.96v15.5H.63c-.35,0-.63.28-.63.63s.28.63.63.63h2.03s0,0,0,0,0,0,0,0h4.35s0,0,0,0,0,0,0,0h3.68s0,0,0,0,0,0,0,0h3.72s0,0,0,0,0,0,0,0h18.93s0,0,0,0,0,0,0,0h3.72s0,0,0,0,0,0,0,0h3.68s0,0,0,0,0,0,0,0h4.35s0,0,0,0,0,0,0,0h2.19c.35,0,.63-.28.63-.63s-.28-.63-.63-.63h-1.56v-15.5h1.11c.35,0,.63-.28.63-.63s-.28-.63-.63-.63h-1.11v-5.89h1.56ZM44.55,38.73h-3.1v-15.5h3.1v15.5ZM23.91,26.79c-1.94,0-3.52,1.58-3.52,3.52v8.43h-1.58v-17.2h10.22v17.2h-1.6v-8.43c0-1.94-1.58-3.52-3.52-3.52ZM3.29,23.23h3.1v15.5h-3.1v-15.5ZM7.65,22.92l2.44-.94v16.76h-2.44v-15.81ZM11.35,19.55h2.47v19.19h-2.47v-19.19ZM16.9,19.55h.67v.73h-2.48v-.73h1.81ZM32.76,19.55v.73h-2.48v-.73h2.48ZM32.76,21.53v1.15h-2.48v-1.15h2.48ZM32.76,29.87h-2.48v-1.15h2.48v1.15ZM32.76,27.47h-2.48v-1.14h2.48v1.14ZM30.28,31.12h2.48v1.15h-2.48v-1.15ZM32.76,25.07h-2.48v-1.15h2.48v1.15ZM30.28,33.52h2.48v1.15h-2.48v-1.15ZM30.28,35.92h2.48v1.15h-2.48v-1.15ZM29.03,20.28h-10.22v-.73h10.22v.73ZM16.7,21.53h.87v1.15h-2.48v-1.15h1.61ZM15.08,31.12h2.48v1.15h-2.48v-1.15ZM15.08,29.87v-1.15h2.48v1.15h-2.48ZM15.08,27.47v-1.14h2.48v1.14h-2.48ZM15.08,25.07v-1.15h2.48v1.15h-2.48ZM15.08,33.52h2.48v1.15h-2.48v-1.15ZM15.08,35.92h2.48v1.15h-2.48v-1.15ZM15.08,38.32h2.48v.41h-2.48v-.41ZM30.28,38.32h2.48v.41h-2.48v-.41ZM34.02,19.55h2.47v1.47s0,.07,0,.11v17.61h-2.47v-19.19ZM37.75,21.98l2.44.94v15.81h-2.44v-16.76ZM40.2,15.78v5.79l-2.45-.94v-1.72s0-.02,0-.03v-4.05l2.45.95ZM36.49,13.78c-.02.09-.02.18,0,.27v4.25h-2.48v-5.88h2.48v1.37ZM32.76,12.41v5.88h-2.48v-5.88h2.48ZM18.82,8.82l5.11-4.39,5.11,4.39v9.48h-10.22v-9.48ZM17.56,18.29h-2.48v-5.88h2.48v5.88ZM13.83,12.41v5.88h-2.48v-4.25c.02-.09.02-.18,0-.27v-1.37h2.48ZM10.1,18.89s0,.02,0,.03v1.71l-2.45.95v-5.79l2.45-.95v4.05ZM6.04,16.09h.36v5.89h-3.11v-5.89h2.75ZM21.65,38.73v-8.43c0-1.25,1.02-2.27,2.27-2.27s2.27,1.02,2.27,2.27v8.43h-4.53ZM44.56,21.98h-3.11v-5.89h3.11v5.89Z" />
                </g>
              </svg>
            </span>
            <span class="text-center small-text">Balochistan PPRA</span>
          </a>
          <a href="https://www.gbppra.gov.pk" target="_blank"
            class="col-lg-2 col-md-4 col-sm-6 services_widgets nav-link d-flex align-items-center justify-content-center gray gap-1">
            <span class="MMenu-icons">
              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 37.47">
                <g id="kpk">
                  <path
                    d="M47.37,36.21h-4.1v-19.76c0-.35-.28-.63-.63-.63h-.53v-2.21c0-.35-.28-.63-.63-.63h-5.12c-.35,0-.63.28-.63.63v2.21h-.53c-.35,0-.63.28-.63.63v1.4h-7.4v-2.09c0-.35-.28-.63-.63-.63h-5.12c-.35,0-.63.28-.63.63v2.09h-7.58v-1.5c0-.35-.28-.63-.63-.63h-.53v-2.21c0-.35-.28-.63-.63-.63h-5.12c-.35,0-.63.28-.63.63v2.21h-.53c-.35,0-.63.28-.63.63v19.87H.63c-.35,0-.63.28-.63.63s.28.63.63.63h46.75c.35,0,.63-.28.63-.63s-.28-.63-.63-.63ZM36.99,14.24h3.86v1.59h-3.86v-1.59ZM22.07,16.38h3.86v1.47h-3.86v-1.47ZM5.8,16.97h6.18v19.14h-6.18v-19.14ZM6.96,14.13h3.86v1.59h-3.86v-1.59ZM13.23,19.1h21.35v17.11h-5.42v-7.93c0-.35-.28-.63-.63-.63h-9.25c-.35,0-.63.28-.63.63v7.93h-5.42v-17.11ZM19.91,36.21v-7.3h8v7.3h-8ZM35.83,36.21v-19.14h6.18v19.14h-6.18Z" />
                  <path
                    d="M17.43,4.68l5.86,3.3v4.04c0,.35.28.63.63.63s.63-.28.63-.63V.63c0-.22-.12-.43-.31-.54-.19-.11-.43-.11-.63,0l-6.17,3.51c-.2.11-.32.32-.32.55,0,.23.12.43.32.54ZM23.29,1.7v4.84l-4.28-2.41,4.28-2.43Z" />
                </g>
              </svg>
            </span>
            <span class="text-center small-text">GB PPRA</span>
          </a>
          <a href="https://kppra.gov.pk" target="_blank"
            class="col-lg-2 col-md-4 col-sm-6 services_widgets nav-link d-flex align-items-center justify-content-center gray gap-1">
            <span class="MMenu-icons">
              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 31.2">
                <g id="gb">
                  <path
                    d="M8.11,13.14c-.35,0-.63.28-.63.63v2.4c0,.35.28.63.63.63s.63-.28.63-.63v-2.4c0-.35-.28-.63-.63-.63Z" />
                  <path
                    d="M11.5,16.43c-.35,0-.63.28-.63.63v2.4c0,.35.28.63.63.63s.63-.28.63-.63v-2.4c0-.35-.28-.63-.63-.63Z" />
                  <path
                    d="M8.28,5.43c-.35,0-.63.28-.63.63v2.4c0,.35.28.63.63.63s.63-.28.63-.63v-2.4c0-.35-.28-.63-.63-.63Z" />
                  <path
                    d="M11.66,8.72c-.35,0-.63.28-.63.63v2.4c0,.35.28.63.63.63s.63-.28.63-.63v-2.4c0-.35-.28-.63-.63-.63Z" />
                  <path
                    d="M39.79,13.14c-.35,0-.63.28-.63.63v2.4c0,.35.28.63.63.63s.63-.28.63-.63v-2.4c0-.35-.28-.63-.63-.63Z" />
                  <path
                    d="M36.41,16.43c-.35,0-.63.28-.63.63v2.4c0,.35.28.63.63.63s.63-.28.63-.63v-2.4c0-.35-.28-.63-.63-.63Z" />
                  <path
                    d="M39.64,9.09c.35,0,.63-.28.63-.63v-2.4c0-.35-.28-.63-.63-.63s-.63.28-.63.63v2.4c0,.35.28.63.63.63Z" />
                  <path
                    d="M36.25,12.38c.35,0,.63-.28.63-.63v-2.4c0-.35-.28-.63-.63-.63s-.63.28-.63.63v2.4c0,.35.28.63.63.63Z" />
                  <path
                    d="M31.81,9.72c0-.35-.28-.63-.63-.63h-14.47c-.35,0-.63.28-.63.63s.28.63.63.63h14.47c.35,0,.63-.28.63-.63Z" />
                  <path
                    d="M28.45,12.39c.35,0,.63-.28.63-.63s-.28-.63-.63-.63h-8.98c-.35,0-.63.28-.63.63s.28.63.63.63h8.98Z" />
                  <path
                    d="M47.37,29.95h-3.15l-1.69-25.45h1.19V0h-3.46v1.39h-.23V0h-3.88v1.39h-.23V0h-3.49v4.5h1.54l-.17,2.54h-1.42v-2.03h-3.53v2.03h-.81v-2.03h-3.53v2.03h-1.11v-2.03h-3.53v2.03h-.81v-2.03h-3.53v2.03h-1.42l-.17-2.54h1.54V0h-3.49v1.39h-.23V0h-3.88v1.39h-.23V0h-3.46v4.5h1.19l-1.69,25.45H.63c-.35,0-.63.28-.63.63s.28.63.63.63h46.74c.35,0,.63-.28.63-.63s-.28-.63-.63-.63ZM33.68,3.24v-1.99h.99v1.39h2.73v-1.39h1.38v1.39h2.73v-1.39h.95v1.99h-8.78ZM30.11,6.26h1.03v.78h-1.03v-.78ZM25.76,6.26h1.03v.78h-1.03v-.78ZM21.12,6.26h1.03v.78h-1.03v-.78ZM16.78,6.26h1.03v.78h-1.03v-.78ZM14.57,8.29h18.78v5.41c-3.13-.45-6.27-.68-9.34-.69h0s-.03,0-.04,0-.03,0-.04,0h0c-3.1,0-6.26.24-9.34.69v-5.41ZM5.45,3.24v-1.99h.95v1.39h2.73v-1.39h1.38v1.39h2.73v-1.39h.99v1.99H5.45ZM7.67,29.95v-4.66c0-1.12.91-2.04,2.04-2.04s2.04.91,2.04,2.04v4.66h-4.08ZM13.01,29.95v-4.66c0-1.82-1.48-3.29-3.29-3.29s-3.29,1.48-3.29,3.29v4.66h-1.48l1.69-25.45h6.04l.63,9.49v.44l.04.22,1.02,15.3h-1.37ZM15.63,29.95l-1-14.98c3.12-.46,6.25-.7,9.32-.7,3.03,0,6.14.24,9.32.69l-1,14.99H15.63ZM36.16,29.95v-4.66c0-1.12.91-2.04,2.04-2.04s2.04.91,2.04,2.04v4.66h-4.08ZM41.49,29.95v-4.66c0-1.82-1.48-3.29-3.29-3.29s-3.29,1.48-3.29,3.29v4.66h-1.37l.99-14.9h.07v-1.06l.63-9.5h6.04l1.69,25.45h-1.48Z" />
                </g>
              </svg>
            </span>
            <span class="text-center small-text">KP PPRA</span>
          </a>
          <a href="https://ppra.punjab.gov.pk" target="_blank"
            class="col-lg-2 col-md-4 col-sm-6 services_widgets nav-link d-flex align-items-center justify-content-center gray gap-1">
            <span class="MMenu-icons">
              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.08 43.7">
                <path id="punjab"
                  d="M.63,43.7h32.82c.35,0,.63-.28.63-.63s-.28-.63-.63-.63h-6.94c-.59-.68-2.43-3.17-.03-5.74.15-.16.21-.39.15-.6-.06-.21-.22-.38-.43-.44-.06-.02-1.18-.32-2.26.05-.01,0-.02,0-.03-.01-.02-.12-.07-.24-.16-.34-2.29-2.28-3-10.75-2.9-18.15.81-.03,1.46-.68,1.46-1.5v-.21c0-.83-.68-1.51-1.51-1.51h-.14v-3.08c.49-.25.84-.74.84-1.33v-.21c0-.78-.61-1.41-1.37-1.48v-2.18c0-1.44-1.07-2.62-2.45-2.82V.63c0-.35-.28-.63-.63-.63s-.63.28-.63.63v2.27c-1.44.15-2.57,1.36-2.57,2.84v2.18c-.77.07-1.37.7-1.37,1.48v.21c0,.59.35,1.08.84,1.33v3.08h-.14c-.83,0-1.51.68-1.51,1.51v.21c0,.82.66,1.48,1.47,1.5.1,7.38-.6,15.85-2.9,18.14-.06.06-.1.12-.13.19-.78-.08-1.43.09-1.48.11-.21.06-.37.23-.43.44-.06.21,0,.44.15.6,2.4,2.56.57,5.06-.02,5.74H.63c-.35,0-.63.28-.63.63s.28.63.63.63ZM13.12,32.01h1.21c-.14,1.19-.3,2.12-.49,2.71-.41.13-.83.27-1.24.45-.01,0-.02.02-.03.02-.25.04-.52.11-.79.2.55-.88.99-2.04,1.34-3.38ZM19.59,17.25c-.01.78-.01,1.67,0,2.66h-.52c0-.87,0-1.76,0-2.66h.51ZM20.54,42.45c-.54-1.94-.94-4.89.07-5.79.49-.43,1.31-.32,2.11-.06-.91,1.14-.97,3.1-.17,5.85h-2.01ZM15.03,35.72s-.02-.01-.02-.02c1.42-.32,2.81-.32,4.2,0,.07.16.15.28.23.39-1.21,1.63-.6,4.81-.2,6.35h-3.67c.43-1.66,1.11-5.27-.55-6.73ZM15.18,34.4c.16-.68.29-1.48.41-2.39h2.79c.11.89.24,1.68.4,2.35-1.19-.19-2.39-.18-3.59.04ZM15.72,30.76c.11-1.12.19-2.34.25-3.59h2.02c.06,1.25.14,2.47.25,3.59h-2.51ZM14.36,21.16h.52c-.02,1.69-.06,3.29-.11,4.76h-.67c.14-1.63.23-3.26.26-4.76ZM16.13,21.16h1.69c.01,1.51.05,3.14.11,4.76h-1.91c.06-1.62.09-3.24.11-4.76ZM19.87,25.92h-.68c-.06-1.47-.1-3.06-.11-4.76h.53c.04,1.5.12,3.13.26,4.76ZM19.25,27.17h.75c.14,1.24.32,2.45.56,3.59h-1.06c-.1-1.05-.18-2.26-.24-3.59ZM17.81,19.91h-1.67c0-.98,0-1.88,0-2.66h1.69c0,.79,0,1.68,0,2.66ZM14.88,17.25c0,.91.01,1.8,0,2.66h-.5c.01-.99,0-1.89,0-2.66h.5ZM13.97,27.17h.74c-.07,1.33-.15,2.54-.24,3.59h-1.05c.23-1.14.42-2.35.56-3.59ZM14.2,36.66c1.02.89.62,3.85.07,5.79h-2.01c.8-2.75.74-4.71-.17-5.85.8-.26,1.62-.36,2.11.06ZM24.94,42.45h-1.08c-.79-2.55-.83-4.38-.09-5.16.29-.31.69-.43,1.05-.47-1.36,2.12-.77,4.24.12,5.64ZM21.44,35.13c-.45-.19-.89-.34-1.34-.47-.18-.59-.34-1.49-.47-2.64h1.22c.32,1.23.72,2.3,1.21,3.15-.21-.03-.42-.04-.61-.04ZM15.09,5.73c0-.89.72-1.61,1.61-1.61h.55c.89,0,1.61.72,1.61,1.61v2.16h-3.77v-2.16ZM13.72,9.4c0-.14.12-.25.25-.25h6.01c.14,0,.25.12.25.25v.21c0,.14-.12.25-.25.25h-6.01c-.14,0-.25-.12-.25-.25v-.21ZM14.56,11.12h4.85v2.9h-4.85v-2.9ZM12.91,15.74v-.21c0-.14.12-.25.25-.25h7.63c.14,0,.25.12.25.25v.21c0,.14-.12.25-.25.25h-7.63c-.14,0-.25-.12-.25-.25ZM10,36.81c.37.04.76.16,1.05.47.75.78.71,2.61-.09,5.17h-1.08c.89-1.4,1.48-3.51.12-5.64Z" />
              </svg>
            </span>
            <span class="text-center small-text">Punjab PRA</span>
          </a>
          <a href="https://www.pprasindh.gov.pk" target="_blank"
            class="col-lg-2 col-md-4 col-sm-6 services_widgets nav-link d-flex align-items-center justify-content-center gray gap-1">
            <span class="MMenu-icons">
              <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 43.77">
                <g id="sindh">
                  <path
                    d="M47.37,42.51h-3.8l-4.03-28.8c-.04-.31-.31-.54-.62-.54h-3.85c.08-.47.14-.93.16-1.4,0,0,0,0,0,0,0,0,0,0,0-.01.01-.17.01-.33.01-.5,0-6.21-5.05-11.26-11.25-11.26s-11.25,5.05-11.25,11.26c0,.17,0,.34.01.47,0,.01,0,.03,0,.04,0,0,0,0,0,0,.02.47.08.94.16,1.4h-4.01c-.31,0-.58.23-.62.54l-3.92,28.79H.63c-.35,0-.63.28-.63.63s.28.63.63.63h46.75c.35,0,.63-.28.63-.63s-.28-.63-.63-.63ZM24,1.25c5.32,0,9.67,4.19,9.97,9.44-2.65-1.21-6.21-1.89-9.97-1.89s-7.32.68-9.97,1.89c.29-5.26,4.65-9.44,9.97-9.44ZM14.05,12.08c2.52-1.28,6.11-2.02,9.95-2.02s7.42.74,9.95,2.02c-.03.37-.08.74-.15,1.09h-2.44c-.35,0-.63.28-.63.63v3.22h-6.73s-.02,0-.03,0c0,0-.02,0-.03,0h-6.73v-3.22c0-.35-.28-.63-.63-.63h-2.39c-.07-.35-.12-.72-.15-1.09ZM9.46,14.43h6.51v3.22c0,.35.28.63.63.63h7.35s.02,0,.03,0c0,0,.02,0,.03,0h7.35c.35,0,.63-.28.63-.63v-3.22h6.4l3.93,28.08h-10.65c-.16-9.24-3.46-16.4-7.65-16.4s-7.49,7.15-7.65,16.4H5.64l3.82-28.08ZM17.59,42.51c.15-8.27,3.03-15.14,6.41-15.14s6.26,6.87,6.41,15.14h-12.81Z" />
                  <path
                    d="M23.11,15.28h1.78c.35,0,.63-.28.63-.63v-1.5c0-.84-.68-1.52-1.52-1.52s-1.52.68-1.52,1.52v1.5c0,.35.28.63.63.63ZM23.74,13.15c0-.29.53-.29.53,0v.88h-.53v-.88Z" />
                  <path
                    d="M19.35,15.28h1.78c.35,0,.63-.28.63-.63v-1.5c0-.84-.68-1.52-1.52-1.52s-1.52.68-1.52,1.52v1.5c0,.35.28.63.63.63ZM19.98,13.15c0-.29.53-.29.53,0v.88h-.53v-.88Z" />
                  <path
                    d="M26.86,15.28h1.78c.35,0,.63-.28.63-.63v-1.5c0-.84-.68-1.52-1.52-1.52s-1.52.68-1.52,1.52v1.5c0,.35.28.63.63.63ZM27.48,13.15c0-.29.53-.29.53,0v.88h-.53v-.88Z" />
                </g>
              </svg>
            </span>
            <span class="text-center small-text">Sindh PPRA</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>